<template>
  <div class="vform-item" :class="{error: error}">
    <slot />
    <span v-if="errorMessage" class="vform-item__error-message">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
import {getPropByPath} from './utils';

export default {
  name: 'VFormItem',
  props: {
    label: String,
    prop: String,
    errors: Object,
    required: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      error: false,
      errorMessage: '',
    };
  },
  computed: {
    form() {
      let parent = this.$parent;
      let parentName = parent.$options._componentTag;
      while (parentName !== 'VForm') {
        if (parentName === 'VFormItem') {
          this.isNested = true;
        }
        parent = parent.$parent;
        parentName = parent.$options._componentTag;
      }
      return parent;
    },
    fieldValue() {
      const model = this.form.model;
      if (!model || !this.prop) {
        return;
      }
      let path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }
      return getPropByPath(model, path).v;
    },
  },
  watch: {
    errors: {
      handler(value) {
        if (value[this.prop]) {
          this.error = true;
          this.errorMessage = value[this.prop].join(',');
        } else {
          this.error = false;
          this.errorMessage = '';
        }
      },
      deep: true,
    },
    fieldValue(val) {
      if (this.form.$options.propsData.errors) {
        this.error = false;
        this.errorMessage = '';
      }
    },
    validateStatus(value) {
      this.validateState = value;
    },
  },
  created() {},
  mounted() {
    this.form.addField(this.prop);
  },
  methods: {},
};
</script>

<style scoped>
.vform-item {
  position: relative;
  padding-top: 1em;
}
.vform-item__error-message {
  display: block;
  font-size: 0.8rem;
  color: var(--input-text-color-error);
  padding-top: 0.4em;
}

.vform-item.error {
  color: var(--input-text-color-error);
}
.vform-item.error >>> .vinput-input {
  border: 1px solid var(--input-border-color-error);
  color: var(--input-text-color-error);
}
</style>
